import React from 'react'
import { connect } from 'react-redux'
import ReCAPTCHA from 'react-google-recaptcha'
import { getRecaptchaKey } from 'util/recaptcha'
import { clearHeader, clearSkip } from 'actions/general'
import RecoverUsernameForm from './form'
import { postUsernameRecovery } from 'actions/username'
import { LoginRoute } from 'resources/routes'
import withRouter from 'hocs/with-router'

function mapStateToProps(state) {
  return {
    success: state.username.getIn(['success'], null),
    loading: state.username.get('loading', false),
    submitError: state.username.get('error', false),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    clearHeader: payload => dispatch(clearHeader(payload)),
    clearSkip: payload => dispatch(clearSkip(payload)),
    postUsernameRecovery: payload => dispatch(postUsernameRecovery(payload)),
  }
}

class RecoverUsername extends React.PureComponent {
  componentDidUpdate(prevProps, prevState) {
    if (
      !this.props.submitError &&
      this.props.success &&
      !this.state.recaptchaPending
    ) {
      this.props.navigate(LoginRoute)
    }
  }

  componentDidMount() {
    this.props.clearHeader()
    this.props.clearSkip()
  }

  _submit = values => {
    if (this.recaptcha.getValue()) {
      this.recaptcha.reset()
    }
    return new Promise((resolve, reject) => {
      this.setState(
        {
          values: { ...values },
          recaptchaPending: true,
        },
        () => {
          this.resolve = resolve
          this.reject = reject
          if (sessionStorage.getItem('disableRecaptcha') === 'true') {
            this._recaptchaChange('disabledForTesting')
          } else {
            this.recaptcha.execute()
          }
        }
      )
    }).then(() => {
      this.setState({ recaptchaPending: false })
    })
  }

  _recaptchaChange = value => {
    const values = this.state.values
    values.captchaToken = value

    this.props.postUsernameRecovery({
      values,
      resolve: this.resolve,
      reject: this.reject,
    })
  }

  render() {
    return (
      <div className='user'>
        <h1 className='heading--main'>Recover Username</h1>
        <span className='heading--subheading'>
          Enter your email address below and we’ll send you your username.
        </span>
        <RecoverUsernameForm
          onSubmit={this._submit}
          loading={this.props.loading}
        />
        <ReCAPTCHA
          ref={recaptcha => {
            this.recaptcha = recaptcha
          }}
          size='invisible'
          sitekey={getRecaptchaKey()}
          onChange={this._recaptchaChange}
        />
      </div>
    )
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RecoverUsername)
)
